
import React from 'react';
import AssignChildrenToParent from '../components/AssignChildrenToParent';

const AssignChildrenToParentPage = () => {
  return (
    <div>
      <AssignChildrenToParent />
    </div>
  );
};

export default AssignChildrenToParentPage;
